<title mat-dialog-title>{{ 'map.telestration.selectChannel' | t }}</title>
<mat-dialog-content *ngIf="chatLoaded$ | async">
  <sn-chat-channel-list (channelSelected)="selectChannel($event)"></sn-chat-channel-list>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button color="danger" (click)="cancel()">{{ 'common.cancel' | t }}</button>
  <button mat-button color="success" [disabled]="!channel" (click)="send()">{{ 'common.select' | t }}</button>
</mat-dialog-actions>
